import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import { DiseasesIcon, ExamsIcon, AllergiesIcon } from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";
import paths from "@icarius-router/paths";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("allergiesSettings"),
      icon: <AllergiesIcon />,
      path: paths.allergiesSettings,
    },
    {
      name: getLocalizedString("medicalExams"),
      icon: <ExamsIcon />,
      path: paths.examsSettings,
    },
    {
      name: getLocalizedString("diseasesSettings"),
      icon: <DiseasesIcon />,
      path: paths.diseasesSettings,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("allergiesExamsDiseases")}
      data={data}
    />
  );
}

export default Index;
